type ComparatorFn<T> = (a: T, b: T) => number

export const sortWith =
  <P>(comparator: ComparatorFn<P>) =>
  (list: P[]): P[] =>
    list.map((i) => i).sort(comparator)
